import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlpha: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconAlpha"><Path d="M16.15 5.78571C15.5151 10.3083 13.2594 19.25 8.91667 19.25C5.50561 19.25 3.71951 15.625 3.75043 12C3.78135 8.375 5.62929 4.75 8.91667 4.75C15.1167 4.75 13.4692 19.25 17.1833 19.25C18.9832 19.25 19.25 17.1786 19.25 16.1429" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconAlpha;
